import {logic as autoLogoutLogic} from './autoLogout/index';
import {logic as authLogic} from './auth/index';
import {logic as socketLogic} from './socket/index';

export default [
  ...autoLogoutLogic,
  ...authLogic,
  ...socketLogic,
];


// WEBPACK FOOTER //
// ./src/util/redux/rootLogic.js